<template>
    <router-view />
</template>

<script>
    import Parse from "@/main.js"
    export default {
        data() {
            return {

            }
        },
    }
</script>

<style></style>